import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal} from "react-bootstrap";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formataDataApi, formataDataExibicao, formataCNPJ, hasPerm } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import axios from 'axios';
import InputMask from "react-input-mask";
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye } from "react-icons/fa";
import namespace from "quill/core/logger";
import Editor from '@monaco-editor/react';
import ClienteIntegracaoHiPlatform from './ClienteIntegracaoHiPlatform';

class ClientesEdit extends Component {
    constructor(props) {
        super(props);
        this.onChangeNome = this.onChangeNome.bind(this);
        this.onChangeCpf = this.onChangeCpf.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeSexo = this.onChangeSexo.bind(this);
        this.onChangeDataNascimento = this.onChangeDataNascimento.bind(this);
        this.onChangeTelefone = this.onChangeTelefone.bind(this);
        this.onChangeCnpj = this.onChangeCnpj.bind(this);
        this.onChangeNomeFantasia = this.onChangeNomeFantasia.bind(this);
        this.onChangeRazaoSocial = this.onChangeRazaoSocial.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.onChangeEndereco = this.onChangeEndereco.bind(this);
        this.onChangeTaxaAdministrativa = this.onChangeTaxaAdministrativa.bind(this);
        this.onChangeNumero = this.onChangeNumero.bind(this);
        this.onChangeComplemento = this.onChangeComplemento.bind(this);
        this.onChangeBairro = this.onChangeBairro.bind(this);
        this.onChangeCidade = this.onChangeCidade.bind(this);
        this.onChangeUF = this.onChangeUF.bind(this);
        this.onChangeImagem = this.onChangeImagem.bind(this);

        this.handleIntegracaoTwilioChange = this.handleIntegracaoTwilioChange.bind(this);
        this.handleIntegracaoSESChange = this.handleIntegracaoSESChange.bind(this);
        this.handleIntegracaoGotoChange = this.handleIntegracaoGotoChange.bind(this);
        this.handleIntegracaoLetsChange = this.handleIntegracaoLetsChange.bind(this);
        this.handleIntegracaoHiChange = this.handleIntegracaoHiChange.bind(this);

        this.enviaCliente = this.enviaCliente.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            tipo_pessoa: 'juridica',
            cpf: '',
            nome: "",
            cnpj: "",
            email: "",
            telefone: "",
            sexo: "",
            data_nascimento: "",
            razao_social: "",
            nome_fantasia: "",
            cep: '',
            endereco: '',
            taxa_administrativa: '',
            numero: '',
            complemento: '',
            bairro: '',
            cidade: '',
            uf: '',
            imagem_upload: '',
            imagem: '',
            integracaoSES: [{id: '', email: '', host: '', password: '', user: '', from_nome: ''}],
            integracaoTwilio: [{id: '', account_sid: '', auth_token: '', twilio_number: '', whatsapp_number: '', messaging_service_sid: ''}],
            integracaoHi: [{id: '', url_api: '', sufixo_nome_template: '', usuario_api: '' , usuario_senha:'', config_id: '', namespace: '', ativo: false, templates: []}],
            integracaoGoto: [{id: '', url_api: '', client_id: '', client_secret:''}],
            integracaoLets: [{id: '', conta_id: '', url_api: '', token:''}],
            imagemHelper: "",
            nomeHelper: "",
            cpfHelper: "",
            cnpjHelper: "",
            emailHelper: "",
            telefoneHelper: "",
            dataNascimentoHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            cepHelper: '',
            enderecoHelper: '',
            taxaAdministrativaHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cidadeHelper: '',
            ufHelper: '',
            erroLoadCli: "",
            cliente_id: "",
            titulo_pagina: "",
            loading: false,
            showModalTemplates: false,
            templatesJson: '', // para armazenar o JSON em formato string para edição
            templatesJsonError: '', // para mostrar erro de validação do JSON
        };

        this.list_sexos = {"F": "Feminino", "M": "Masculino"};

        this.list_tipos_pessoa = {"fisica": "Física", "juridica": "Jurídica"};

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            if(!hasPerm('change_clientes')) {
                this.props.router.navigate("/sem-permissao");
                return;
            }

            this.setState({
                cliente_id: id,
                titulo_pagina: 'Editando Cliente',
                loading: true,
                erroLoadCli: ''
            })

            //consulta os dados do cliente na api
            api.get(`/pessoas/clientes/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadCli: '',
                    nome: dados.dados_pessoa.nome,
                    cnpj: (dados.dados_pessoa.cpf_cnpj) ? formataCNPJ(dados.dados_pessoa.cpf_cnpj) : '',
                    email: dados.dados_pessoa.email,
                    imagem: dados.imagem,
                    telefone: dados.dados_pessoa.telefone,
                    nome_fantasia: dados.dados_pessoa.nome_fantasia,
                    razao_social: dados.dados_pessoa.razao_social,
                    cep: dados.dados_pessoa.cep,
                    endereco: dados.dados_pessoa.endereco,
                    taxa_administrativa: dados.taxa_administrativa,
                    numero: dados.dados_pessoa.numero,
                    complemento: dados.dados_pessoa.complemento,
                    bairro: dados.dados_pessoa.bairro,
                    cidade: dados.dados_pessoa.cidade,
                    uf: dados.dados_pessoa.uf,
                    loading: false
                }, () => {
                    this.carregarIntegracaoSES();
                    this.carregarIntegracaoTwilio();
                    this.carregarIntegracaoGoto();
                    this.carregarIntegracaoLets();
                    this.carregarIntegracaoHi();
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar cliente, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadCli: erro_msg,
                })
            });
        }
        else {
            if(!hasPerm('add_clientes')) {
                this.props.router.navigate("/sem-permissao");
                return;
            }

            this.setState({
                cliente_id: '',
                titulo_pagina: 'Adicionar Cliente',
                loading: false,
                erroLoadCli: '',
            })
        }
    }

    enviaCliente = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: '',
            cpfHelper: '',
            cnpjHelper: '',
            emailHelper: '',
            telefoneHelper: '',
            dataNascimentoHelper: '',
        });

        //vererifica se é edição ou adição
        const url = (this.state.cliente_id) ? '/pessoas/clientes/'+this.state.cliente_id+'/' : '/pessoas/clientes/'
        const metodo = (this.state.cliente_id) ? 'put' : 'post'

        if (this.state.imagem_upload) {
            formData.append('imagem', this.state.imagem_upload);
        }

        formData.append('nome', this.state.nome_fantasia);
        formData.append('cpf_cnpj', this.state.tipo_pessoa === 'fisica' ? this.state.cpf : this.state.cnpj);
        formData.append('email', this.state.email);
        formData.append('telefone', this.state.telefone);
        formData.append('tipo_pessoa', this.state.tipo_pessoa);
        formData.append('nome_fantasia', this.state.nome_fantasia);
        formData.append('razao_social', this.state.razao_social);
        formData.append('cep', this.state.cep);
        formData.append('endereco', this.state.endereco);
        formData.append('taxa_administrativa', this.state.taxa_administrativa);
        formData.append('numero', this.state.numero);
        formData.append('complemento', this.state.complemento);
        formData.append('bairro', this.state.bairro);
        formData.append('cidade', this.state.cidade);
        formData.append('uf', this.state.uf);
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.cliente_id) ? 'Cliente atualizado com sucesso' : 'Cliente cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.cliente_id){
                this.props.router.navigate("/clientes");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar cliente, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'cpf'){
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'cnpj'){
                        this.setState({ cnpjHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        this.setState({ cnpjHelper: value })
                    }
                    if(key === 'email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'telefone'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'data_nascimento'){
                        this.setState({ dataNascimentoHelper: value })
                    }
                    if(key === 'razao_social'){
                        this.setState({ razaoSocialHelper: value })
                    }
                    if(key === 'nome_fantasia'){
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'cep'){
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'endereco'){
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'taxa_administrativa'){
                        this.setState({ taxaAdministrativaHelper: value })
                    }
                    if(key === 'numero'){
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cidade'){
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'uf'){
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'imagem'){
                        this.setState({ imagemHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    onChangeTipoPessoa = (e) => {
        this.setState({
            tipo_pessoa: e.target.value,
            cpf: '',
            cnpj: '',
        });
    };

    onChangeNome = (e) => {            
        this.setState({ nome: e.target.value })
    };

    onChangeCpf = (e) => {   
        this.setState({ cpf: e.target.value })
    };

    onChangeCnpj = (e) => {   
        this.setState({ cnpj: e.target.value })
    };

    onChangeEmail = (e) => {   
        this.setState({ email: e.target.value })
    };

    onChangeTelefone = (e) => {   
        this.setState({ telefone: e.target.value })
    };

    onChangeSexo = (e) => {   
        this.setState({ sexo: e.target.value })
    };

    onChangeDataNascimento = (e) => {           
        this.setState({ data_nascimento: e.target.value })
    };

    onChangeRazaoSocial = (e) => {           
        this.setState({ razao_social: e.target.value })
    };

    onChangeNomeFantasia = (e) => {           
        this.setState({ nome_fantasia: e.target.value })
    };

    onChangeCep(e) {
        const cep = e.target.value;
        this.setState({ cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                        console.log("CEP não encontrado.");
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    onChangeEndereco(e) {
        this.setState({ endereco: e.target.value });
    }
    
    onChangeTaxaAdministrativa(e) {
        let valor = e.target.value;

        // Remove qualquer caracter não numérico (exceto o ponto) para garantir uma entrada válida
        valor = valor.replace(/[^0-9.]/g, '');

        // Atualiza o estado com o valor formatado corretamente
        this.setState({ taxa_administrativa: valor });
    }

    onChangeNumero(e) {
        this.setState({ numero: e.target.value });
    }

    onChangeComplemento(e) {
        this.setState({ complemento: e.target.value });
    }

    onChangeBairro(e) {
        this.setState({ bairro: e.target.value });
    }

    onChangeCidade(e) {
        this.setState({ cidade: e.target.value });
    }

    onChangeUF(e) {
        this.setState({ uf: e.target.value });
        console.log("U Alterado = ");
        console.log(this.state.uf);
    }

    onChangeImagem = (e) => {
        this.setState({ imagem_upload: e.target.files[0] });
    };

    //Carregar Integração SES
    carregarIntegracaoSES = () => {
        if (this.state.cliente_id) {
            api.get(`/integracao/ses/?cliente_id=${this.state.cliente_id}`)
                .then(response => {
                    const resultados = response.data.results;
                    let integracaoSES = null; // Começa com null para o caso de não haver resultados
    
                    if (resultados.length > 0) {
                        const integracao = resultados[0]; // Acessa apenas o primeiro resultado
                        integracaoSES = [{
                            id: integracao.id,
                            email: integracao.email,
                            host: integracao.host,
                            password: integracao.password,
                            user: integracao.user,
                            from_nome: integracao.from_nome
                        }];
                        this.setState({ integracaoSES: integracaoSES });
                    }
                    
                    
                })
                .catch(error => {
                    console.error('Erro ao carregar integração SES:', error);
                    
                    let erro_msg = 'Erro ao carregar integração SES, tente novamente';
    
                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    //Carregar Integração Twilio
    carregarIntegracaoTwilio = () => {
        if (this.state.cliente_id) {
            api.get(`/integracao/twilio/?cliente_id=${this.state.cliente_id}`)
                .then(response => {
                    const resultados = response.data.results;
                    let integracaoTwilio = null; // Começa com null para o caso de não haver resultados
    
                    if (resultados.length > 0) {
                        const integracao = resultados[0]; // Acessa apenas o primeiro resultado
                        integracaoTwilio = [{
                            id: integracao.id,
                            account_sid: integracao.account_sid,
                            auth_token: integracao.auth_token,
                            twilio_number: integracao.twilio_number,
                            whatsapp_number: integracao.whatsapp_number,
                            messaging_service_sid: integracao.messaging_service_sid,
                        }];
                        this.setState({ integracaoTwilio: integracaoTwilio });
                    }
                    
                    
                })
                .catch(error => {
                    console.error('Erro ao carregar integração Twilio:', error);
                    
                    let erro_msg = 'Erro ao carregar integração Twilio, tente novamente';
    
                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregarIntegracaoHi = () => {
        if (this.state.cliente_id) {
            api.get(`/integracao/hiplatform/?cliente_id=${this.state.cliente_id}`)
                .then(response => {
                    const resultados = response.data.results;

                    if (resultados.length > 0) {
                        const integracao = resultados[0];
                        const integracaoHi = [{
                            id: integracao.id,
                            url_api: integracao.url_api,
                            sufixo_nome_template: integracao.sufixo_nome_template,
                            usuario_api: integracao.usuario_api,
                            usuario_senha: integracao.usuario_senha,
                            config_id: integracao.config_id,
                            namespace: integracao.namespace,
                            ativo: integracao.ativo,
                            templates: integracao.templates || []
                        }];
                        this.setState({ integracaoHi });
                    }
                })
                .catch(error => {
                    console.error('Erro ao carregar integração HiPlataform:', error);
                    
                    let erro_msg = 'Erro ao carregar integração HiPlataform, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    });
                });
        }
    };

    carregarIntegracaoGoto = () => {
        if (this.state.cliente_id) {
            api.get(`/integracao/gotoconnect/?cliente_id=${this.state.cliente_id}`)
                .then(response => {
                    const resultados = response.data.results;
                    let integracaoGoto = null; // Começa com null para o caso de não haver resultados
    
                    if (resultados.length > 0) {
                        const integracao = resultados[0]; // Acessa apenas o primeiro resultado
                        integracaoGoto = [{
                            id: integracao.id,
                            url_api: integracao.url_api,
                            client_id: integracao.client_id,
                            client_secret: integracao.client_secret,
                        }];
                        this.setState({ integracaoGoto: integracaoGoto });
                    }
                    
                    
                })
                .catch(error => {
                    console.error('Erro ao carregar integração Goto:', error);
                    
                    let erro_msg = 'Erro ao carregar integração Goto, tente novamente';
    
                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregarIntegracaoLets = () => {
        if (this.state.cliente_id) {
            api.get(`/integracao/letssign/?cliente_id=${this.state.cliente_id}`)
                .then(response => {
                    const resultados = response.data.results;
                    let integracaoLets = null; // Começa com null para o caso de não haver resultados
    
                    if (resultados.length > 0) {
                        const integracao = resultados[0]; // Acessa apenas o primeiro resultado
                        integracaoLets = [{
                            id: integracao.id,
                            conta_id: integracao.conta_id,
                            url_api: integracao.url_api,
                            token: integracao.token,
                        }];
                        this.setState({ integracaoLets: integracaoLets });
                    }
                    
                    
                })
                .catch(error => {
                    console.error('Erro ao carregar integração LetsSign:', error);
                    
                    let erro_msg = 'Erro ao carregar integração LetsSing, tente novamente';
    
                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    handleIntegracaoTwilioChange = (index, event, fieldName) => {
        const integracaoTwilio = [...this.state.integracaoTwilio];
        
        const { name, value } = event.target;
        integracaoTwilio[index] = { ...integracaoTwilio[index], [name]: value };
        
        this.setState({ integracaoTwilio });
    };

    salvarIntegracaoTwilio = (index) => {
        const integracaoTwilio = this.state.integracaoTwilio[index];
        const url = integracaoTwilio.id ? `/integracao/twilio/${integracaoTwilio.id}/` : '/integracao/twilio/';
        const metodo = integracaoTwilio.id ? 'put' : 'post';

        const dadosIntegracao = {
            account_sid: integracaoTwilio.account_sid,
            auth_token: integracaoTwilio.auth_token,
            twilio_number: integracaoTwilio.twilio_number,
            whatsapp_number: (integracaoTwilio.whatsapp_number) ? integracaoTwilio.whatsapp_number: '',
            messaging_service_sid: (integracaoTwilio.messaging_service_sid) ? integracaoTwilio.messaging_service_sid : '',
            cliente_id: this.state.cliente_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosIntegracao,
        })
        .then(response => {

            if (!integracaoTwilio.id) {
                this.setState(prevState => {
                    const dadosAtualizados = [...prevState.integracaoTwilio];
                    dadosAtualizados[index].id = response.data.id;
                    return { integracaoTwilio: dadosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = 'Dados de integração com Twilio configurados';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao configurar dados de integração com Twilio, verifique os campos e tente novamente';           
            let content = ''; 

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content
            })
        });
    };

    handleIntegracaoHiChange = (index, event = null, fieldName = null, value = null) => {
        const integracaoHi = [...this.state.integracaoHi];
    
        if (fieldName && value !== null) {
            // Caso de clique no botão (Ativo/Inativo)
            integracaoHi[index] = { ...integracaoHi[index], [fieldName]: value };
        } else if (event) {
            // Caso de mudança em um campo de texto
            const { name, value: inputValue } = event.target;
            integracaoHi[index] = { ...integracaoHi[index], [name]: inputValue };
        }
    
        this.setState({ integracaoHi });
    };
    
    

    salvarIntegracaoHi = (index) => {
        const integracaoHi = this.state.integracaoHi[index];
    
        const url = integracaoHi.id ? `/integracao/hiplatform/${integracaoHi.id}/` : '/integracao/hiplatform/';
        const metodo = integracaoHi.id ? 'put' : 'post';
    
        const dadosIntegracao = {
            url_api: integracaoHi.url_api,
            ativo: integracaoHi.ativo,
            sufixo_nome_template: integracaoHi.sufixo_nome_template,
            usuario_api: integracaoHi.usuario_api,
            usuario_senha: integracaoHi.usuario_senha,
            config_id: integracaoHi.config_id,
            namespace: integracaoHi.namespace,
            cliente_id: this.state.cliente_id,
            templates: integracaoHi.templates || [],
        };
    
        api({
            method: metodo,
            url: url,
            data: dadosIntegracao,
        })
            .then(response => {
                if (!integracaoHi.id) {
                    this.setState(prevState => {
                        const dadosAtualizados = [...prevState.integracaoHi];
                        dadosAtualizados[index].id = response.data.id;
                        return { integracaoHi: dadosAtualizados };
                    });
                }
    
                const MySwal = withReactContent(Swal);
                const textSwal = 'Dados de integração com HiPlatform configurados';
    
                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao configurar dados de integração com HiPlatform, verifique os campos e tente novamente';
                let content = '';
    
                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response && error.response.status === 400) {
                    const campos = error.response.data;
                }
    
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: <p>{erro_msg}</p>,
                    html: content,
                });
            });
    };
    


    handleIntegracaoSESChange = (index, event, fieldName) => {
        const integracaoSES = [...this.state.integracaoSES];
        
        const { name, value } = event.target;
        integracaoSES[index] = { ...integracaoSES[index], [name]: value };
        
        this.setState({ integracaoSES });
    };

    salvarIntegracaoSES = (index) => {
        const integracaoSES = this.state.integracaoSES[index];
        const url = integracaoSES.id ? `/integracao/ses/${integracaoSES.id}/` : '/integracao/ses/';
        const metodo = integracaoSES.id ? 'put' : 'post';

        const dadosIntegracao = {
            email: integracaoSES.email,
            host: integracaoSES.host,
            password: integracaoSES.password,
            user: integracaoSES.user,
            from_nome: integracaoSES.from_nome,
            cliente_id: this.state.cliente_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosIntegracao,
        })
        .then(response => {

            if (!integracaoSES.id) {
                this.setState(prevState => {
                    const dadosAtualizados = [...prevState.integracaoSES];
                    dadosAtualizados[index].id = response.data.id;
                    return { integracaoSES: dadosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = 'Dados de integração com SES configurados';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao configurar dados de integração com SES, verifique os campos e tente novamente';           
            let content = ''; 

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content
            })
        });
    };

    handleIntegracaoGotoChange = (index, event, fieldName) => {
        const integracaoGoto = [...this.state.integracaoGoto];
        
        const { name, value } = event.target;
        integracaoGoto[index] = { ...integracaoGoto[index], [name]: value };
        
        this.setState({ integracaoGoto });
    };

    salvarIntegracaoGoto = (index) => {
        const integracaoGoto = this.state.integracaoGoto[index];
        const url = integracaoGoto.id ? `/integracao/gotoconnect/${integracaoGoto.id}/` : '/integracao/gotoconnect/';
        const metodo = integracaoGoto.id ? 'put' : 'post';

        const dadosIntegracao = {
            url_api: integracaoGoto.url_api,
            client_id: integracaoGoto.client_id,
            client_secret: integracaoGoto.client_secret,
            cliente_id: this.state.cliente_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosIntegracao,
        })
        .then(response => {

            if (!integracaoGoto.id) {
                this.setState(prevState => {
                    const dadosAtualizados = [...prevState.integracaoGoto];
                    dadosAtualizados[index].id = response.data.id;
                    return { integracaoGoto: dadosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = 'Dados de integração com Goto configurados';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao configurar dados de integração com Goto, verifique os campos e tente novamente';           
            let content = ''; 

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content
            })
        });
    };
    
    handleIntegracaoLetsChange = (index, event, fieldName) => {
        const integracaoLets = [...this.state.integracaoLets];
        
        const { name, value } = event.target;
        integracaoLets[index] = { ...integracaoLets[index], [name]: value };
        
        this.setState({ integracaoLets });
    };

    salvarIntegracaoLets = (index) => {
        const integracaoLets = this.state.integracaoLets[index];
        const url = integracaoLets.id ? `/integracao/letssign/${integracaoLets.id}/` : '/integracao/letssign/';
        const metodo = integracaoLets.id ? 'put' : 'post';

        const dadosIntegracao = {
            conta_id: integracaoLets.conta_id,
            url_api: integracaoLets.url_api,
            token: integracaoLets.token,
            cliente_id: this.state.cliente_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosIntegracao,
        })
        .then(response => {

            if (!integracaoLets.id) {
                this.setState(prevState => {
                    const dadosAtualizados = [...prevState.integracaoLets];
                    dadosAtualizados[index].id = response.data.id;
                    return { integracaoLets: dadosAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = 'Dados de integração com LetsSign configurados';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao configurar dados de integração com LetsSign, verifique os campos e tente novamente';           
            let content = ''; 

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content
            })
        });
    };

    handleOpenModalTemplates = () => {
        const templates = this.state.integracaoHi[0].templates || [];
        this.setState({ 
            showModalTemplates: true,
            templatesJson: JSON.stringify(templates, null, 4), // formatado com indentação
            templatesJsonError: ''
        });
    };

    handleCloseModalTemplates = () => {
        this.setState({ showModalTemplates: false });
    };

    handleTemplatesJsonChange = (e) => {
        this.setState({ templatesJson: e.target.value, templatesJsonError: '' });
    };

    salvarTemplatesJson = () => {
        try {
            const parsedJson = JSON.parse(this.state.templatesJson);
            
            // Atualiza o state da integração com os templates
            const integracaoHi = [...this.state.integracaoHi];
            integracaoHi[0] = { ...integracaoHi[0], templates: parsedJson };
            
            this.setState({ integracaoHi, templatesJsonError: '' }, () => {
                // Salva na API
                this.salvarIntegracaoHi(0);
                this.handleCloseModalTemplates();
            });
        } catch (error) {
            this.setState({ templatesJsonError: 'JSON inválido. Verifique a sintaxe e tente novamente.' });
        }
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosCliente" id="tabs-cliente" className="aditus-tabs">
                    <Tab eventKey="dadosCliente" title="Dados do Cliente">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaCliente}>
                                    <Row className="mb-3 d-none">
                                        <Col sm={12} xs={12}>
                                            <Form.Label>Tipo Pessoa</Form.Label>
                                            <div className="mb-3">
                                            {
                                                Object.keys(this.list_tipos_pessoa).map((key, index) => ( 
                                                <Form.Check inline type="radio" label={this.list_tipos_pessoa[key]} key={key} id={key} name="tipo_pessoa" value={key} onChange={this.onChangeTipoPessoa} checked={ key === this.state.tipo_pessoa ? true : false } />
                                                ))
                                            }                                              
                                            </div>
                                        </Col>
                                    </Row>
                                    <h4>Dados da Empresa</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca</Form.Label>
                                                <Form.Control type="file" name="imagem_upload" onChange={this.onChangeImagem} ref={this.fileInput} />
                                                <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.imagemHelper}</Form.Text>
                                                {this.state.imagem && (
                                                    <div>
                                                        <img src={this.state.imagem} alt="Logomarca Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {this.state.tipoPessoa === 'fisica' ? (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CPF</Form.Label>
                                                <Form.Control as={IMaskInput} required mask="000.000.000-00" placeholder="CPF" name="cpf" id="formCpf" value={this.state.cpf} onChange={this.onChangeCpf} />
                                                <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        ) : (
                                            <>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CNPJ</Form.Label>
                                                        <Form.Control as={IMaskInput} required mask="00.000.000/0000-00" placeholder="CNPJ" name="cnpj" id="formCnpj" value={this.state.cnpj} onChange={this.onChangeCnpj} />
                                                        <Form.Text id="formCpfHelpBlock" className="text-danger">{this.state.cnpjHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>   
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Razão Social</Form.Label>
                                                        <Form.Control type="text" required placeholder="Razão Social" name="razao_social" id="forRazaoSocial" value={this.state.razao_social} onChange={this.onChangeRazaoSocial} />                            
                                                        <Form.Text id="formRazaoSocialHelpBlock" className="text-danger">{this.razaoSocialHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nome Fantasia</Form.Label>
                                                        <Form.Control type="text" required placeholder="Nome Fantasia" name="nome_fantasia" id="formNomeFantasia" value={this.state.nome_fantasia} onChange={this.onChangeNomeFantasia} />                            
                                                        <Form.Text id="formNomeFantasiaHelpBlock" className="text-danger">{this.nomeFantasiaHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </>
                                        )}

                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control type="email" required placeholder="E-mail" name="email" id="formEmail" value={this.state.email} onChange={this.onChangeEmail} />                            
                                                <Form.Text id="formEmailHelpBlock" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Telefone</Form.Label>
                                                <Form.Control as={IMaskInput} required mask="(00) 00000-0000" placeholder="Telefone do cliente" name="telefone" id="formTelefone" value={this.state.telefone} onChange={this.onChangeTelefone} />
                                                <Form.Text id="formTelefoneHelpBlock" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <h4 className="mt-3">Endereço</h4>
                                        <Col sm={12} xs={12}>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CEP</Form.Label>
                                                        <Form.Control as={IMaskInput} required mask="00000-000"  type="text" placeholder="CEP" value={this.state.cep} onChange={this.onChangeCep} />
                                                        <Form.Text id="formCEPHelpBlock" className="text-danger">{this.state.cepHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Endereço</Form.Label>
                                                        <Form.Control type="text" required placeholder="Endereço" value={this.state.endereco} onChange={this.onChangeEndereco} />
                                                        <Form.Text id="formEnderecoHelpBlock" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Número</Form.Label>
                                                        <Form.Control type="text" required placeholder="Número" value={this.state.numero} onChange={this.onChangeNumero} />
                                                        <Form.Text id="formNumeroHelpBlock" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Complemento</Form.Label>
                                                        <Form.Control type="text" placeholder="Complemento" value={this.state.complemento} onChange={this.onChangeComplemento} />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Bairro</Form.Label>
                                                        <Form.Control type="text" placeholder="Bairro" value={this.state.bairro} onChange={this.onChangeBairro} />
                                                        <Form.Text id="formBairroHelpBlock" className="text-danger">{this.state.bairroHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cidade</Form.Label>
                                                        <Form.Control type="text" placeholder="Cidade" value={this.state.cidade} onChange={this.onChangeCidade} />
                                                        <Form.Text id="formCidadeHelpBlock" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>UF</Form.Label>
                                                        <Form.Control as="select" value={this.state.uf} required onChange={this.onChangeUF}>
                                                            <option value="">Selecione o Estado</option>
                                                            {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                <option key={sigla} value={sigla}>{nome}</option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Text id="formUFHelpBlock" className="text-danger">{this.state.ufHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>                                    
                                        </Col>
                                    </Row>
                                    <h4 className="mt-3">Configurações</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Taxa Administrativa (%)</Form.Label>
                                                <Form.Control type="text" placeholder="Informar a porcentagem de taxa administrativa" value={this.state.taxa_administrativa} onChange={(e) => this.onChangeTaxaAdministrativa(e)} />
                                                {/*}
                                                <InputMask
                                                    mask="09.99"
                                                    value={this.state.taxa_administrativa ? this.state.taxa_administrativa : ''}
                                                    onChange={(e) => this.onChangeTaxaAdministrativa(e)}
                                                    className="form-control"
                                                    placeholder="Informar a porcentagem de taxa administrativa"
                                                >
                                                    {(inputProps) => <Form.Control {...inputProps} type="text" required />}
                                                </InputMask>*/}
                                                <Form.Text id="formTaxaAdministrativaHelpBlock" className="text-danger">{this.state.taxaAdministrativaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>  
                                    {this.state.erroLoadCli ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadCli}
                                    </Alert> : ''
                                    }                    
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                    {this.state.cliente_id && (
                        <Tab eventKey="integracoesCliente" title="Integrações">
                            <Card className="cardDestaque">
                                <Card.Body> 
                                    <h4>Integrações</h4>

                                    <div className="row-list">
                                        <Row>
                                            <Col sm={12}>
                                                <h4><strong>Integração Amazon SES</strong></h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>E-mail</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="email" 
                                                        required={true}
                                                        value={this.state.integracaoSES[0].email} 
                                                        onChange={e => this.handleIntegracaoSESChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome From</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="from_nome" 
                                                        required={true}
                                                        value={this.state.integracaoSES[0].from_nome} 
                                                        onChange={e => this.handleIntegracaoSESChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Host</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="host" 
                                                        required={true}
                                                        value={this.state.integracaoSES[0].host} 
                                                        onChange={e => this.handleIntegracaoSESChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>User</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="user" 
                                                        required={true}
                                                        value={this.state.integracaoSES[0].user} 
                                                        onChange={e => this.handleIntegracaoSESChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Password</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="password" 
                                                        required={true}
                                                        value={this.state.integracaoSES[0].password} 
                                                        onChange={e => this.handleIntegracaoSESChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarIntegracaoSES(0)}><FaCheck className="me-1" /> Salvar Dados</Button>
                                    </div>

                                    {/*
                                    <div className="row-list">
                                        <Row>
                                            <Col sm={12}>
                                                <h4><strong>Integração Twilio</strong></h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Account SID</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="account_sid" 
                                                        required={true}
                                                        value={this.state.integracaoTwilio[0].account_sid} 
                                                        onChange={e => this.handleIntegracaoTwilioChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Auth Token</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="auth_token" 
                                                        required={true}
                                                        value={this.state.integracaoTwilio[0].auth_token} 
                                                        onChange={e => this.handleIntegracaoTwilioChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Twilio Phone Number</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="twilio_number" 
                                                        required={true}
                                                        value={this.state.integracaoTwilio[0].twilio_number} 
                                                        onChange={e => this.handleIntegracaoTwilioChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Whatsapp Number</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="whatsapp_number" 
                                                        value={this.state.integracaoTwilio[0].whatsapp_number} 
                                                        onChange={e => this.handleIntegracaoTwilioChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Messaging Service SID</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="messaging_service_sid" 
                                                        value={this.state.integracaoTwilio[0].messaging_service_sid} 
                                                        onChange={e => this.handleIntegracaoTwilioChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarIntegracaoTwilio(0)}><FaCheck className="me-1" /> Salvar Dados</Button>
                                    </div>
                                    */}

                                    <div className="row-list">
                                        <Row>
                                            <Col sm={12}>
                                                <h4><strong>Integração HiPlatform</strong></h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>URL da API</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="url_api" 
                                                        required={true}
                                                        value={this.state.integracaoHi[0].url_api} 
                                                        onChange={e => this.handleIntegracaoHiChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Sufixo para Template</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="sufixo_nome_template" 
                                                        required={true}
                                                        value={this.state.integracaoHi[0].sufixo_nome_template} 
                                                        onChange={e => this.handleIntegracaoHiChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Usuário API</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="usuario_api" 
                                                        required={true}
                                                        value={this.state.integracaoHi[0].usuario_api} 
                                                        onChange={e => this.handleIntegracaoHiChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Senha API</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="usuario_senha" 
                                                        required={true}
                                                        value={this.state.integracaoHi[0].usuario_senha} 
                                                        onChange={e => this.handleIntegracaoHiChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Config ID</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="config_id" 
                                                        required={true}
                                                        value={this.state.integracaoHi[0].config_id} 
                                                        onChange={e => this.handleIntegracaoHiChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Namespace</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="namespace" 
                                                        required={true}
                                                        value={this.state.integracaoHi[0].namespace} 
                                                        onChange={e => this.handleIntegracaoHiChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={2} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label></Form.Label>
                                                    <div>
                                                        <Button
                                                            variant={this.state.integracaoHi[0].ativo ? "success" : "outline-secondary"}
                                                            onClick={() => this.handleIntegracaoHiChange(0, null, "ativo", true)}
                                                        >
                                                            Ativo
                                                        </Button>
                                                        {' '}
                                                        <Button
                                                            variant={!this.state.integracaoHi[0].ativo ? "danger" : "outline-secondary"}
                                                            onClick={() => this.handleIntegracaoHiChange(0, null, "ativo", false)}
                                                        >
                                                            Inativo
                                                        </Button>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarIntegracaoHi(0)}><FaCheck className="me-1" /> Salvar Dados</Button>
                                        {' '}
                                        <Button 
                                            variant="primary" 
                                            className="btn-sm" 
                                            onClick={this.handleOpenModalTemplates}
                                        >
                                            <FaStream className="me-1" /> Templates
                                        </Button>

                                        {/* Modal de Templates */}
                                        <Modal 
                                            show={this.state.showModalTemplates} 
                                            onHide={this.handleCloseModalTemplates}
                                            size="xl"
                                            backdrop="static"
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title>Templates HiPlatform - Editor JSON</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                {this.state.templatesJsonError && (
                                                    <Alert variant="danger">{this.state.templatesJsonError}</Alert>
                                                )}
                                                <Form.Group>
                                                    <Form.Label>Edite o JSON dos templates abaixo:</Form.Label>
                                                    <Editor
                                                        height="500px"
                                                        defaultLanguage="json"
                                                        value={this.state.templatesJson}
                                                        onChange={(value) => this.setState({ templatesJson: value, templatesJsonError: '' })}
                                                        theme="vs-dark"
                                                        options={{
                                                            minimap: { enabled: false },
                                                            fontSize: 14,
                                                            formatOnPaste: true,
                                                            formatOnType: true,
                                                            automaticLayout: true,
                                                            tabSize: 4,
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" size="sm" onClick={this.handleCloseModalTemplates}>
                                                    Cancelar
                                                </Button>
                                                <Button variant="success" size="sm" onClick={this.salvarTemplatesJson}>
                                                    <FaCheck className="me-1" /> Salvar Templates
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </div>

                                    <div className="row-list">
                                        <Row>
                                            <Col sm={12}>
                                                <h4><strong>Integração Goto</strong></h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>URL da API</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="url_api" 
                                                        required={true}
                                                        value={this.state.integracaoGoto[0].url_api} 
                                                        onChange={e => this.handleIntegracaoGotoChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Client ID</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="client_id" 
                                                        required={true}
                                                        value={this.state.integracaoGoto[0].client_id} 
                                                        onChange={e => this.handleIntegracaoGotoChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Client Secret</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="client_secret" 
                                                        required={true}
                                                        value={this.state.integracaoGoto[0].client_secret} 
                                                        onChange={e => this.handleIntegracaoGotoChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarIntegracaoGoto(0)}><FaCheck className="me-1" /> Salvar Dados</Button>
                                    </div>

                                    <div className="row-list">
                                        <Row>
                                            <Col sm={12}>
                                                <h4><strong>Integração LetsSign</strong></h4>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Conta ID</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="conta_id" 
                                                        required={true}
                                                        value={this.state.integracaoLets[0].conta_id} 
                                                        onChange={e => this.handleIntegracaoLetsChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>URL da API</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="url_api" 
                                                        required={true}
                                                        value={this.state.integracaoLets[0].url_api} 
                                                        onChange={e => this.handleIntegracaoLetsChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Token</Form.Label>
                                                    <Form.Control 
                                                        type="password" 
                                                        name="token" 
                                                        required={true}
                                                        value={this.state.integracaoLets[0].token} 
                                                        onChange={e => this.handleIntegracaoLetsChange(0, e)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Button variant="success" className="btn-sm" onClick={() => this.salvarIntegracaoLets(0)}><FaCheck className="me-1" /> Salvar Dados</Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}
                    {this.state.cliente_id && (
                        <Tab eventKey="integracaoHiPlatform" title="Integração HiPlatform">
                            <ClienteIntegracaoHiPlatform clienteId={this.state.cliente_id} />
                        </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ClientesEdit);